// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ChartTab_Wrapper__25wki","container":"ChartTab_container__2FsuP","tabs":"ChartTab_tabs__1-nm-","nav":"ChartTab_nav__w-t_s","active":"ChartTab_active__1pajN"};